// extracted by mini-css-extract-plugin
export default {"root":"Teams_root__+Qu21","lastUpdated":"Teams_lastUpdated__HRz6f marketplaceBodyFontStyles"};